import { createStyles } from "antd-style";

import type { BaseLogoProps, CompanyLogoProps } from "./types";

function getLogoMarginBottom(size: BaseLogoProps["size"], marginXL: number) {
  if (size === "large") return marginXL * 2;

  if (size === "small") return 0;

  return marginXL;
}

function getMobileLogoMarginBottom(size: BaseLogoProps["size"], marginLG: number) {
  if (size === "small") return 0;

  return marginLG;
}

export function getLogoHeight(size: BaseLogoProps["size"]) {
  if (size === "large") return 48;

  if (size === "small") return 21;

  return 40;
}

function getLogoBoxWidth(size: BaseLogoProps["size"]) {
  if (size === "large") return 320;

  if (size === "small") return 180;

  return 260;
}

function getMobileLogoBoxWidth(size: BaseLogoProps["size"]) {
  if (size === "large") return 240;

  if (size === "small") return 180;

  return 220;
}

function getLogoBoxHeight(size: BaseLogoProps["size"]) {
  if (size === "large") return 48;

  if (size === "small") return 65;

  return 40;
}

function getMobileLogoBoxHeight(size: BaseLogoProps["size"]) {
  if (size === "small") return 65;

  return 30;
}

export function getSkeletonWidth(size: BaseLogoProps["size"]) {
  if (size === "large") return 144;

  if (size === "small") return 72;

  return 120;
}

export function getSkeletonHeight(size: BaseLogoProps["size"]) {
  if (size === "large") return 48;

  if (size === "small") return 21;

  return 40;
}

export const getLogoTitleLevel = (size: NonNullable<CompanyLogoProps["size"]>) => {
  if (size === "large") return 3;

  if (size === "small") return 5;

  return 4;
};

export const useLogoStyles = createStyles(({ token, css }, { size }: BaseLogoProps) => ({
  logoContainer: css`
    text-align: center;
    margin-bottom: ${getLogoMarginBottom(size, token.marginXL)}px;

    @media (max-width: ${token.screenMD}px) {
      margin-bottom: ${getMobileLogoMarginBottom(size, token.marginLG)}px;
    }
  `,
  logoBox: css`
    width: ${getLogoBoxWidth(size)}px;
    height: ${getLogoBoxHeight(size)}px;

    @media (max-width: ${token.screenMD}px) {
      width: ${getMobileLogoBoxWidth(size)}px;
      height: ${getMobileLogoBoxHeight(size)}px;
    }
  `,
  imageLogo: css`
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  `,
  textLogo: css`
    && {
      margin: 0;
    }
  `,
}));
